import React from "react";
import { AlertTriangle, Button, Check, InfoCircle, Spinner } from "@opendate-app/setlist";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

const Status = ({ icon: Icon, tone, action, children }) => (
  <span className={`membership-save-status is-${tone}`} data-testid="membership-save-bar-status">
    {Icon ? <Icon width={16} height={16} aria-hidden="true" /> : <span className="membership-save-dot" aria-hidden="true" />}
    <span role="status">{children}</span>
    {action}
  </span>
);

const SaveBar = ({ archived, isEditing, isSaving, changeCount, errorCount, showErrors, onShowErrors, onCancel, onDiscard, onSave }) => {
  if (archived) {
    return (
      <div className="membership-save-bar" role="region" aria-label="Save">
        <Status icon={InfoCircle} tone="muted">
          Archived memberships are read only
        </Status>
      </div>
    );
  }

  let status;
  if (showErrors && errorCount) {
    status = (
      <Status
        icon={AlertTriangle}
        tone="error"
        action={
          <Button variant="link-color" size="sm" onClick={onShowErrors}>
            Show me
          </Button>
        }
      >
        {plural(errorCount, "field")} need{errorCount === 1 ? "s" : ""} attention
      </Status>
    );
  } else if (!isEditing) {
    status = (
      <Status icon={InfoCircle} tone="muted">
        New membership · saves as a draft
      </Status>
    );
  } else if (changeCount) {
    status = <Status tone="warning">{plural(changeCount, "unsaved change")}</Status>;
  } else {
    status = (
      <Status icon={Check} tone="success">
        All changes saved
      </Status>
    );
  }

  return (
    <div className="membership-save-bar" role="region" aria-label="Save">
      {status}
      <div className="membership-save-actions">
        {!isEditing ? (
          <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
        ) : changeCount ? (
          <Button variant="secondary" onClick={onDiscard} disabled={isSaving}>
            Discard
          </Button>
        ) : null}
        <Button variant="primary" onClick={onSave} disabled={isSaving || (isEditing && !changeCount)}>
          {isSaving ? <Spinner size="sm" label="Saving" /> : null}
          {isEditing ? "Save changes" : "Create membership"}
        </Button>
      </div>
    </div>
  );
};

export default SaveBar;
